/**
 * @generated SignedSource<<eb6a56729727a9c06998e22b1b5ff114>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SalesAssociateTrackingPositioningRule = "FIRST" | "LAST" | "SAME";
import { FragmentRefs } from "relay-runtime";
export type TurnListProvider_movement$data = {
  readonly id: string;
  readonly name: string;
  readonly positioningRule: SalesAssociateTrackingPositioningRule;
  readonly stepToClose: {
    readonly id: string;
  } | null;
  readonly nextSteps: ReadonlyArray<{
    readonly id: string;
    readonly positioningRule: SalesAssociateTrackingPositioningRule;
    readonly nextSteps: ReadonlyArray<{
      readonly id: string;
      readonly positioningRule: SalesAssociateTrackingPositioningRule;
      readonly stepToClose: {
        readonly id: string;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"utils_unfinishedMovement" | "OutOfStoreListItem_moviment" | "MovementsModal_movementStep">;
    }> | null;
    readonly stepToClose: {
      readonly id: string;
      readonly positioningRule: SalesAssociateTrackingPositioningRule;
      readonly " $fragmentSpreads": FragmentRefs<"OutOfStoreListItem_moviment" | "MovementsModal_movementStep">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"utils_unfinishedMovement" | "OutOfStoreListItem_moviment" | "MovementsModal_movementStep">;
  }> | null;
  readonly " $fragmentSpreads": FragmentRefs<"utils_unfinishedMovement" | "OutOfStoreListItem_moviment" | "MovementsModal_movementStep">;
  readonly " $fragmentType": "TurnListProvider_movement";
};
export type TurnListProvider_movement$key = {
  readonly " $data"?: TurnListProvider_movement$data;
  readonly " $fragmentSpreads": FragmentRefs<"TurnListProvider_movement">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positioningRule",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesAssociateTrackingMovementStep",
  "kind": "LinkedField",
  "name": "stepToClose",
  "plural": false,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineDataFragmentSpread",
  "name": "utils_unfinishedMovement",
  "selections": [
    (v0/*: any*/),
    (v2/*: any*/)
  ]
},
v4 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "OutOfStoreListItem_moviment"
},
v5 = {
  "kind": "InlineDataFragmentSpread",
  "name": "MovementsModal_movementStep",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ]
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TurnListProvider_movement",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v1/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesAssociateTrackingMovementStep",
      "kind": "LinkedField",
      "name": "nextSteps",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesAssociateTrackingMovementStep",
          "kind": "LinkedField",
          "name": "nextSteps",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesAssociateTrackingMovementStep",
          "kind": "LinkedField",
          "name": "stepToClose",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SalesAssociateTrackingMovementStep",
  "abstractKey": null
};
})();

(node as any).hash = "1f3884c7d52d5092afe3b9d0e91ce655";

export default node;
